const textProps = {
  title: "Checkout",
  subtitle:
    "We’ll show you the checkout page optimization tips that’ll make your visitors want.",
  image: require("assets/img/sections/photo-15.jpg").default,
  skewColor: "blueGray",
};
export default textProps;
